import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class IntlTellInputService {

    tellChanged = new Subject<string>();
    isTellError = new Subject<boolean>();

    constructor() {
    }

}
